export const styles = {
  controllerContainer: (theme) => ({
    minWidth: 250,
    p: 1,
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    mt: 1,
    boxShadow: theme.shadows[7],
  }),
  volumeSlider: (theme) => ({
    "& .MuiSlider-track": {
      border: "none",
    },
    "& .MuiSlider-rail": {
      backgroundColor: theme.palette.common.black,
    },
    "& .MuiSlider-thumb": {
      backgroundColor: theme.palette.common.white,
      "&:hover, &.Mui-focusVisible, &.Mui-active": {
        boxShadow: theme.shadows[0],
      },
    },
  }),
}
